import fromAnyToString from 'utils/converters/fromAnyToString';

const equalStrings = (str1, str2) => fromAnyToString(str1).toUpperCase().trim() === fromAnyToString(str2).toUpperCase().trim();

export default equalStrings;
